import baseAPI from '@/api';
import { PaginatedRequestWithDateFilter } from '@/models/pagination/paginated-request-with-date-filter.dto';
import { PaginatedResponse } from '@/models/pagination/paginated-response.dto';
import { ReferralVoucher } from '@/models/referral-voucher';
import { QueryFunctionContext } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { UseReferralVoucherMeQueryKey } from './props';

export async function fetchReferralVoucherMe({
  queryKey,
}: QueryFunctionContext<UseReferralVoucherMeQueryKey>): Promise<
  PaginatedResponse<ReferralVoucher>
> {
  const params: PaginatedRequestWithDateFilter = queryKey[1];

  const response: AxiosResponse<PaginatedResponse<ReferralVoucher>> =
    await baseAPI.get<PaginatedResponse<ReferralVoucher>>(
      '/referral-vouchers/me',
      {
        params,
      },
    );

  return response.data;
}
